export default function({ dispatch, commit }, code) {
    //commit('startedAuthentication')

    // POST /auth/login
    return dispatch('post', {
        url: '/provider/auth/mfa',
        data: {
            mfa : code
        }
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        //commit('receivedToken', token)
        if(response.payload && response.payload.cp)
            return {
                changePassword: true
            }
        return dispatch('user/getUser', {}, { root: true })
        .then(() => {
            return dispatch('ws/connect', {}, { root: true })
        })
        .then(() => {
            return response
        })
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
